import { Component, OnInit } from '@angular/core';
import { OffersService } from '../../../services/offers.service';
import { OffersValidCsvIface } from '../../../interfaces/offersValidCsv.iface';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-csv-upload-errors',
  templateUrl: './csv-upload-errors.component.html',
  styleUrls: ['./csv-upload-errors.component.scss']
})
export class CsvUploadErrorsComponent implements OnInit {
  public csvErrors: OffersValidCsvIface[] = [];

  constructor(private offersService: OffersService, public translate: TranslateService) {}

  ngOnInit() {
    this.offersService.csvValidationInfo$.subscribe(errors => (this.csvErrors = errors));
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/offers/csv-upload-errors/csv-upload-errors.component.ts